import React, { useState } from 'react';
import ListPrompts from './Prompts/ListPrompts'; // Assuming ListPrompts is in the same directory
import { QuestionnairePage } from './Questionnaire/Questionnaire.page';
import ListLLMs from './LLM/ListLLMs';
import { KnowledgeBasePage } from './KnowledgeBase/ListKnowledgeBase';
import { KnowledgeBaseOverridesPage } from './KnowledgeBaseOverrides/ListKnowledgeBaseOverrides';
import { SegmentedTabs } from 'src/modules/ambient_solo/components/PastEncounter/SegmentedTabs';

const AiComponents = ({ isMinimized }) => {
  const [activeTab, setActiveTab] = useState('Prompts');

  const options = [
    { label: 'Prompts', value: 'Prompts' },
    { label: 'Questionnaire', value: 'Questionnaire' },
    { label: 'LLMs', value: 'LLMs' },
    { label: 'Knowledge Base', value: 'Knowledge Base' },
    { label: 'Knowledge Base Overrides', value: 'Knowledge Base Overrides' },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'Prompts':
        return <ListPrompts />;
      case 'Questionnaire':
        return <QuestionnairePage />;
      case 'LLMs':
        return <ListLLMs />;
      case 'Knowledge Base':
        return <KnowledgeBasePage />;
      case 'Knowledge Base Overrides':
        return <KnowledgeBaseOverridesPage />;
      default:
        return <ListPrompts />;
    }
  };

  return (
    <div
      className={`page-wrapper ${isMinimized ? 'page-wrapper--minimized' : ''}`}
    >
      <div className="flex justify-start">
        <SegmentedTabs
          options={options}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          disabled={false}
        />
      </div>
      <div style={{ marginTop: '20px' }}>{renderContent()}</div>
    </div>
  );
};

export default AiComponents;
